import {getAxios} from './axios'
import {addAuthTokenData} from './member';

export function getMemberGuestbook(offset) {
    let axios = getAxios();

    return axios.request({
        url: '/member/guestbook/',
        method: 'get',
        params: addAuthTokenData({offset})
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberGuestbook.js